import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import { SubCategoryWrapper } from './transactions-modules/sub-category-wrapper/subCategoryList'
import { TransactionsMenu } from './TransactionsMenu'
import { CollectOrdersWrapper } from '../data-administration/data-admininstration-list/collect-orders/collectOrdersList'
import { ReturnOrdersWrapper } from '../data-administration/data-admininstration-list/return-orders/returnOrderrsList'
import { ProcessingRecordList } from '../data-administration/data-admininstration-list/processing-record/processingRecodList'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { PurchaseOrdersWrapper } from '../data-administration/data-admininstration-list/purchase-orders/purchaseOrdersList'
import { LabManagementWrapper } from './transactions-modules/lab-management/labManagementList'
import { TestCer } from './transactions-modules/Test Certificates/testCertificate'

import { useAuth } from '../../auth'

import WorkingStockPage from '../data-administration/data-admininstration-list/WorkingStock/WorkingStockPage'
import { ShipmentWrapper } from '../data-administration/data-admininstration-list/RecieveShipment/RecieveShipment'
import { OperationWrapper } from './transactions-modules/operations/OperationWrapper'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Transactions',
    path: '/apps/transactions',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const TransactionsPage = () => {

  const { currentUser, isSupplyChainManager, auth }: any = useAuth()
  console.log("currentUser is", currentUser.userType)


  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<TransactionsMenu />} />
        <Route
          path='collect-orders'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Material Inward</PageTitle>
              <CollectOrdersWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='shipment'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Receive Shipment</PageTitle>
              <ShipmentWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='processing-record'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Process</PageTitle>
              <ProcessingRecordList />
            </SuspensedView>
          }
        />
        <Route
          path='supply-orders'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Material Transfer</PageTitle>
              <ReturnOrdersWrapper />
            </SuspensedView>
          }
        />
        {/* <Route
          path='purchase-orders'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Purchase Order</PageTitle>
              <PurchaseOrdersWrapper />
            </SuspensedView>
          }
        /> */}
        <Route
          path='items'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>External Sale</PageTitle>
              <SubCategoryWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='lab-mgmt'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Lab Management</PageTitle>
              <LabManagementWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='test-certificate'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Test Certificates</PageTitle>
              <TestCer />
            </SuspensedView>
          }
        />
        <Route
          path='operation'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Operation</PageTitle>
              <OperationWrapper />
            </SuspensedView>
          }
        />

        <Route path='working-stock/*' element={<WorkingStockPage />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default TransactionsPage
